import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Attention } from '../interfaces/attention';
import { DatabaseRecord } from '../mixins/database-record';
import { ActivityLog, HasActivityLogs } from '../mixins/has-activity-logs';
import { AgencyBlocAddress, HasAgencyBlocAddresses } from './agency-bloc-address';
import { AgencyBlocCustomField } from './agency-bloc-custom-field';
import { AgencyBlocEntity } from './agency-bloc-entities';
import { HasEmailAttribute, HasFullNameAttribute } from './search-results-record';

export class AgencyBlocGroup extends DatabaseRecord(AgencyBlocCustomField(HasAgencyBlocAddresses(HasActivityLogs(AgencyBlocEntity(HasEmailAttribute(HasFullNameAttribute())))))) {
  public readonly $entityID = 'groupID';
  public readonly $entityType = 'Group';
  public readonly $entityDateLabel = 'Lead Date';

  public advisor_portal_id = 0;
  public groupID = 0;
  public groupName = '';
  public dba = '';
  public fedTaxID = '';
  public employees = 0;
  public description = '';
  public website = '';
  public type = '';
  public projectCode = '';
  public leadSource = '';
  public leadSourceOther = '';
  public leadSourceAgentName = '';
  public leadDate = new Date();
  public accountManagerName = '';
  public servicingAgentName = '';
  public fax = '';
  public industry = '';
  public status = '';
  public cellPhone = '';
  public homePhone = '';
  public businessPhone = '';
  public addresses: AgencyBlocAddress[] = [];
  public webinar_participants: AgencyBlocWebinarParticipant[] = [];
  public attention?: Attention;
  public compensation?: GROUP_COMPENSATION[];
  // public premiumTarget?: any;

  /**
   * An AgencyBlocGroup can be assigned to an AdvisorPortal if it is not already assigned to one.
   */
  public get can_be_assigned(): boolean {
    return !this.advisor_portal_id;
  }

  /**
   * Get the entity date for this Model. Usually used for sorting and displaying in the UI.
   */
  public get entityDate(): Date {
    return new Date(this.leadDate);
  }

  /**
   * Get the entity ID for this Model. Usually used for sorting and displaying in the UI.
   */
  public get entityId(): number {
    return this.groupID;
  }

  constructor(data?: AgencyBlocGroup) {
    super(data);
    Object.assign(this, data);

    this.customFields = data?.customFields || [];

    if (data) {
      if (this.created_at) this.created_at = new Date(this.created_at);
      if (this.updated_at) this.updated_at = new Date(this.updated_at);
      if (this.deleted_at) this.deleted_at = new Date(this.deleted_at);
      if (this.logs) this.logs = this.logs.map((log) => new ActivityLog(log));
      this.$entityId = this.groupID;
      this.$entityDate = this.leadDate;
    }
  }

  public createFormGroup(entityType?: string): FormGroup {
    if (entityType === 'Group') {
      return new FormGroup({
        advisorGroupName: new FormControl('', [Validators.required]),
        status: new FormControl(''),
        type: new FormControl(''),
        projectCode: new FormControl(''),
      });
    }
    const group = super.createFormGroup();

    group.patchValue({
      groupName: new FormControl(this.groupName, []),
      dba: new FormControl(this.dba, []),
      description: new FormControl(this.description, []),
      leadDate: new FormControl(this.leadDate, []),
      type: new FormControl(this.type, [Validators.required]),
      projectCode: new FormControl(this.projectCode, [Validators.required]),
    });

    return group;
  }
}

export interface AgencyBlocWebinarParticipant {
  id: number;
  agency_bloc_agent_id: number;
  agency_bloc_group_id: number;
  participants: number;
  webinar_date: Date;
}

export interface GROUP_COMPENSATION {
  compensation: ADVISOR_COMPENSATIONS;
  full_name: string;
  placement_rating: PLACEMENT_RATING;
}

export interface ADVISOR_COMPENSATIONS {
  [key: string]: ADVISOR_COMPENSATION[];
}

export interface ADVISOR_COMPENSATION {
  declined: number;
  placed: ADVISOR_POLICY[];
  retired: number;
  submitted: ADVISOR_POLICY[];
  withdrawn: number;
}

export interface ADVISOR_POLICY {
  PolicyID: number;
  actual_premium: number;
  credited: number;
}
export interface PLACEMENT_RATING {
  last_12_months: number;
  last_year: number;
  this_year: number;
  timeframe: number;
}
